import { useState } from 'react';
import { initSortConfig } from '../../../utils';

const Filters = ({ losesAccess }) => {
  const [query, setQuery] = useState('');
  const [findRole, setFindRole] = useState(null);
  const [sortConfig, setSortConfig] = useState(initSortConfig);

  const setSortColumn = async (column) => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setSortConfig((prev) => ({ ...prev, column }));
  };

  const toggleSortDirection = async () => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setSortConfig((prev) => ({
      ...prev,
      direction: prev.direction === 'asc' ? 'desc' : 'asc',
    }));
  };

  const handleSort = async (column) => {
    const lostAccess = await losesAccess?.();
    if (lostAccess) return;
    setSortConfig((prev) => {
      const sameColumn = prev.column === column;
      return {
        column,
        direction: sameColumn
          ? (prev.direction === 'asc' ? 'desc' : 'asc')
          : 'asc',
      };
    });
  };

  return {
    query,
    setQuery,
    findRole,
    setFindRole,
    sortConfig,
    setSortColumn,
    toggleSortDirection,
    handleSort,
  };
};

export default Filters;
